export default {
  view: 'login',
  loading: false,
  loggedIn: false,
  successMsg: false,
  authenticationErrorMsg: false,
  authenticationErrorCode: false,
  facebookID: null
}
